import {
	ElAutocomplete,
	ElDropdown,
	ElDropdownMenu,
	ElDropdownItem,
	ElMenu,
	ElInput,
	ElInputNumber,
	ElRadio,
	ElRadioGroup,
	ElCheckbox,
	ElCheckboxGroup,
	ElSwitch,
	ElSelect,
	ElOption,
	ElDatePicker,
	ElTimeSelect,
	ElTimePicker,
	ElPopover,
	ElTooltip,
	ElBreadcrumb,
	ElTabs,
	ElTabPane,
	ElTag,
	ElTree,
	ElAlert,
	ElSlider,
	ElUpload,
	ElProgress,
	ElBadge,
	ElCard,
	ElRate,
	ElSteps,
	ElCarousel,
	ElScrollbar,
	ElCollapse,
	ElCascader,
	ElColorPicker,
	ElTransfer,
	ElContainer,
	ElTimeline,
	ElLink,
	ElDivider,
	ElImage,
	ElCalendar,
	ElBacktop,
	ElCascaderPanel,
	ElAvatar,
	ElDrawer,
	ElStatistic,
	ElPopconfirm,
	ElSkeleton,
	ElEmpty,
	ElDescriptions,
	ElResult,
} from "element-plus"
const components:any = {
	ElAutocomplete,
	ElDropdown,
	ElDropdownMenu,
	ElDropdownItem,
	ElMenu,
	ElInput,
	ElInputNumber,
	ElRadio,
	ElCheckbox,
	ElRadioGroup,
	ElCheckboxGroup,
	ElSwitch,
	ElSelect,
	ElOption,
	ElDatePicker,
	ElTimeSelect,
	ElTimePicker,
	ElPopover,
	ElTooltip,
	ElBreadcrumb,
	ElTabs,
	ElTabPane,
	ElTag,
	ElTree,
	ElAlert,
	ElSlider,
	ElUpload,
	ElProgress,
	ElBadge,
	ElCard,
	ElRate,
	ElSteps,
	ElCarousel,
	ElScrollbar,
	ElCollapse,
	ElCascader,
	ElColorPicker,
	ElTransfer,
	ElContainer,
	ElTimeline,
	ElLink,
	ElDivider,
	ElImage,
	ElCalendar,
	ElBacktop,
	ElCascaderPanel,
	ElAvatar,
	ElDrawer,
	ElStatistic,
	ElPopconfirm,
	ElSkeleton,
	ElEmpty,
	ElDescriptions,
	ElResult,
};
  
const allKeys = Object.keys(components);

const otherComponents:any = {}
const whiteList = [
	"ElContainer",
	"ElHeader",
	"ElAside",
	"nameKey",
	"ElMain",
	"ElMenu",
	"ElSubmenu",
	"ElMenuItem",
	"ElMenuItemGroup",
	"ElCard",
]

for (let index = 0; index < allKeys.length; index++) {
	const key = allKeys[index];
	const nameKey = components[key].name;
	if (nameKey && nameKey.includes("El") && !whiteList.includes(nameKey)) {
		const replaceElWithTq = nameKey.replace("El", "Tq");
		otherComponents[replaceElWithTq] = components[key];
	}
}


console.log('otherComponents', otherComponents);

export default otherComponents;